export default {
  createCSV: function (items, fileName, colspanValues = false, repeatRowHeader = false) {
    const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
    const header = Object.keys(items[0])
    let csv = items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
    csv.unshift(header.join(','))
    csv = csv.join('\r\n')

    var exportedFilenmae = fileName + '.xlsx' || 'export.csv'
    // console.log('csv in export-> ', csv)
    var tableDataStart = '<table>';
    var tableDataEnd = '</table>';
    var tableDataRowHeaderStart = "<thead><tr><th>Number</th>";
    for (var h=0; h < header.length; h++) {
      tableDataRowHeaderStart += '<th>' + header[h].replace(/_/g, ' ') + '</th>'
    }
    tableDataRowHeaderStart += '</tr></thead>'
    var tableDataRowDataStart = "<tbody>"
    /*let datacsv = csv.split('\r\n')
    console.log('datacsv-> ', datacsv[2])
    for (var c = 1; c < datacsv.length; c++) {
      let rowData = datacsv[c].split(',')
      tableDataRowDataStart += '<tr>'
      for (var h=1; h < rowData.length; h++) {
        tableDataRowDataStart += '<td>' + rowData[h] + '</td>'
      }
      tableDataRowDataStart += '</tr>'
    tableDataRowDataStart += '</tbody>'*/
    let rowcount = 1
    items.filter(function (name, index) {
      let fillerRows = []
      if (colspanValues !== false) {
        if (name[colspanValues].includes(' $&$ ')) {
          let temp = name[colspanValues].split(' $&$ ')
          tableDataRowDataStart += '<tr><td rowspan=' + temp.length + '>' + (rowcount + index) + '</td>'
        } else {
          tableDataRowDataStart += '<tr><td>' + (rowcount + index) + '</td>'
        } 
      } else {
        tableDataRowDataStart += '<tr><td>' + (rowcount + index) + '</td>'
      }
      let h = header.map(function(fieldName) {
        if (colspanValues !== false)
          var temp = name[colspanValues].split(' $&$ ')
        if (colspanValues !== false) {
          name[fieldName] = (name[fieldName] === null) ? "" : name[fieldName]
          console.log('exportCSV fieldName ', fieldName, name)
          if (name[fieldName].includes(' $&$ ')) {
            let fieldData = name[fieldName].split(' $&$ ')
            let filler = 0
            fillerRows[fieldName] = []
            fieldData.map (function (x) {
              if (filler === 0) {
                tableDataRowDataStart += '<td>' + x.replace('undefined', '') + '</td>'
                filler++
              }
              else {
                fillerRows[fieldName].push('<td>' + x.replace('undefined', '') + '</td>')
              }
            })
          } else if (repeatRowHeader !== false) {
              // console.log(' ExportToCSV.js repeatRowHeader ', repeatRowHeader,' fieldName ', fieldName)
              if (repeatRowHeader.includes(fieldName)) {
                fillerRows[fieldName] = []
                tableDataRowDataStart += '<td>' + name[fieldName].replace('undefined', '') + '</td>'
                for (var r = 1; r < temp.length; r++) {
                  fillerRows[fieldName].push('<td>' + name[fieldName].replace('undefined', '') + '</td>')
                }
              } else if (name[colspanValues].includes(' $&$ ')) {
                tableDataRowDataStart += '<td rowspan=' + temp.length + '>' + name[fieldName].replace('undefined', '') + '</td>'
              } else {
                tableDataRowDataStart += '<td>' + name[fieldName].replace('undefined', '') + '</td>'
              }
          } else if (colspanValues !== false) {
            if (name[colspanValues].includes(' $&$ ')) {
              tableDataRowDataStart += '<td rowspan=' + temp.length + '>' + name[fieldName].replace('undefined', '') + '</td>'
            } else {
              tableDataRowDataStart += '<td>' + name[fieldName].replace('undefined', '') + '</td>'
            }
          }
        } else {
            if ((typeof name[fieldName] === 'boolean' || typeof name[fieldName] === 'number')) {
              console.log('boolean', name[fieldName])
              if (name[fieldName] == undefined) {
                name[fieldName] = ''
              }
              tableDataRowDataStart += '<td>'+name[fieldName]+'</td>'
            } 
            else if (Array.isArray(name[fieldName])) {
              console.log(' array ', name[fieldName])
              tableDataRowDataStart += '<td>'
              name[fieldName].forEach(record => {
                if (record == undefined) {
                  record = ''
                }
                tableDataRowDataStart += record+'<BR>'
              })
            tableDataRowDataStart += '</td>'
            } else {
              console.log('82name string', name[fieldName])
              tableDataRowDataStart += '<td>' + name[fieldName].replace('undefined', '') + '</td>'
            }
            //tableDataRowDataStart += '<td>' + name[fieldName].replace('undefined', '') + '</td>'
          }
      })
      tableDataRowDataStart += '</tr>'
      // fillerRows += '</tr>'
      if (colspanValues !== false)
      if (name[colspanValues].includes(' $&$ ')) {
        if (fillerRows[colspanValues].length > 0) {
          let teamRows = ''
          for (var i = 0; i < fillerRows[colspanValues].length; i ++) {
            teamRows += '<tr>'
            Object.keys(fillerRows).map(function(x){
              teamRows += fillerRows[x][i]
            })
            teamRows += '</tr>'
          }
          tableDataRowDataStart += teamRows
        }
      }
    })

    tableDataRowDataStart += '</tbody>'
    var table = tableDataStart + tableDataRowHeaderStart + tableDataRowDataStart + tableDataEnd
// console.log(table)
    /* var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
      var ctx = {worksheet: fileName || 'Worksheet', table: table}
      window.location.href = uri + base64(format(template, ctx))
      */
     var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>';

      var base64 = function(s) { 
        return window.btoa(unescape(encodeURIComponent(s))); 
      };
    
      var format = function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; });
      };
    
      var ctx = { worksheet: fileName || 'Worksheet', table: table };
    
      // Create the Blob with the generated Excel file content
      var blob = new Blob([format(template, ctx)], { type: 'application/vnd.ms-excel' });
    
      // Create a link element and trigger the download
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName || 'Worksheet'}.xls`;
    
      // Append the link to the document and trigger the download
      document.body.appendChild(link);
      link.click();
    
      // Clean up by removing the link and revoking the object URL
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
      console.log('blob 160')
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ExportToCSV.js